import { Button, Stack, Typography } from '@karma/components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SadIconFilled } from '@karma/components/icons';
import Alooma from 'services/alooma';
import * as ALOOMA from 'consts/alooma';
import { oldApiInstance } from 'functions/request';
import useAction from 'hooks/useAction';
import { showErrorAlert } from 'store/alerts/actions';
import { setValue } from 'store/giftCards/actions';
import { Body } from './ModalBodyGiftCardCancel.style';

const ModalBodyGiftCardCancel = ({ closeModal }) => {
  const [isCanceling, setIsCanceling] = useState(false);
  const { t } = useTranslation();
  const contextDataAttrs = Alooma.useContextDataAttrs();
  const showErrorAlertFunc = useAction(showErrorAlert);
  const setValueFunc = useAction(setValue);

  const cancelRedemptionHandler = async () => {
    setIsCanceling(true);

    try {
      await oldApiInstance.post('/plus/cancel_withdrawal');
      setValueFunc({ waitingConfirmation: false });
      closeModal();
    } catch (e) {
      showErrorAlertFunc({ message: 'app:pleaseTryAgain' });
      setIsCanceling(false);
    }
  };

  return (
    <Body>
      <SadIconFilled width={60} height={60} />
      <Stack spacing={8} direction="column">
        <Typography variant="h3">{t('app:areYouSure')}</Typography>
        <Typography variant="paragraphLarge">{t('app:thisWillCancelRedemption')}</Typography>
      </Stack>
      <Button
        size="medium"
        onClick={cancelRedemptionHandler}
        {...contextDataAttrs}
        data-alooma-element={ALOOMA.ELEMENTS.CANCEL_REDEMPTION}
        loading={isCanceling}
        fullWidth
      >
        {t('app:yesCancelRedemption')}
      </Button>
      <Button
        size="medium"
        type="outline"
        onClick={closeModal}
        {...contextDataAttrs}
        data-alooma-element={ALOOMA.ELEMENTS.NEVER_MIND}
        disabled={isCanceling}
        fullWidth
      >
        {t('app:neverMind')}
      </Button>
    </Body>
  );
};

export default ModalBodyGiftCardCancel;
